/**
 * `/accounts/:accountId/assistants/:AssistantID/observability` — the only place
 * the agent's log is mounted (`features/agent-observability/router.tsx`, under
 * the agent in `AppRouter.tsx`). Anchored at both ends, so anything nested below
 * never matches; a substring test would also catch an id that happens to
 * contain the segment.
 */
const OBSERVABILITY_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/observability\/?$/;

export function isObservabilityPath(pathname: string): boolean {
  return OBSERVABILITY_ROUTE.test(pathname);
}
